module.exports = __webpack_public_path__ + "assets/img/GENERAL_START_PLUGIN.90dcee07.svg";